import SpriteSymbol from "../../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-submit",
  "use": "icon-submit-usage",
  "viewBox": "0 0 16 16",
  "content": "<symbol viewBox=\"0 0 16 16\" id=\"icon-submit\"><path d=\"M14.8 7.5 2.7 2.4h-.2c-.3-.1-.5.2-.5.5L2.9 8 2 13.1c-.1.3.2.6.5.6h.2l12.1-5.2c.4-.2.4-.8 0-1M3.1 12.4l.6-3.5L8.9 8l-5.2-.9-.6-3.5L13.3 8z\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol